import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import { StatusLabel } from '@components/StatusLabel'
import { formatNumber } from '@atheneum/api/dist/lib'

class RevenuesTable extends Component {
  static propTypes = {
    revenues: PropTypes.object,
    sidebarStore: PropTypes.object,
    revenueSum: PropTypes.number,
    honSum: PropTypes.number,
    costSum: PropTypes.number,
    marginSum: PropTypes.number
  }

  renderMarginPercentage (honorarium, revenue) {
    const quotient = (1 - honorarium / revenue) * 100
    if (Number.isFinite(quotient)) {
      let className
      if (quotient < 55) {
        className = 'red-text'
      } else if (quotient < 65) {
        className = 'orange-text'
      } else if (quotient < 75) {
        className = 'yellow-text'
      } else {
        className = 'green-text'
      }
      return <div className={className}>{formatNumber(quotient)}</div>
    } else {
      return '-'
    }
  }

  render () {
    const { revenues, revenueSum, honSum, costSum, marginSum } = this.props
    let stillRequiredSum = 0
    let expertsDeliveredSum = 0
    let expertsAcceptedSum = 0
    let expertsInterviewedSum = 0
    revenues.map(res => {
      stillRequiredSum = stillRequiredSum + res.stillRequired
      expertsDeliveredSum = expertsDeliveredSum + res.expertsDelivered
      expertsAcceptedSum = expertsAcceptedSum + res.expertsAccepted
      expertsInterviewedSum = expertsInterviewedSum + res.expertsInterviewed
    })
    return (
      <table className='table-wrapper revenues m-t-xl'>
        <thead>
          <tr>
            <th>Project name</th>
            <th>Status</th>
            <th>Project account</th>
            <th>Atheneum contact(s)</th>
            <th>Client contact(s)</th>
            <th>Country</th>
            <th>Contract type</th>
            <th className='right-align'>Still Req</th>
            <th className='right-align'>Deliv. Month</th>
            <th className='right-align'>Accept Total</th>
            <th className='right-align'>Int. Month</th>
            <th className='right-align'>Revenue (EUR)</th>
            <th className='right-align'>Honorarium (EUR)</th>
            <th className='right-align'>Costs (EUR)</th>
            <th className='right-align'>Margin (EUR)</th>
            <th className='right-align'>Margin (%)</th>
          </tr>
        </thead>
        {revenues.map(revenue => {
          return (
            <tbody key={revenue.id}>
              <tr>
                <td>
                  <span
                    className='row--link'
                    onClick={() =>
                      this.props.sidebarStore.openSidebar({
                        template: 'project',
                        id: revenue.id
                      })
                    }
                  >
                    {revenue.projectName}
                  </span>
                </td>
                <td>
                  <StatusLabel
                    statusId={revenue.statusId}
                    statusesType='projectStatuses'
                  />
                </td>
                <td>
                  <span className='text-wrapper'>{revenue.projectAccount}</span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {revenue.atheneumContacts}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>{revenue.clientNames}</span>
                </td>
                <td>
                  <span className='text-wrapper'>{revenue.country}</span>
                </td>
                <td>
                  <span className='text-wrapper'>{revenue.contractTypes}</span>
                </td>
                <td>
                  <span className='text-wrapper right-align'>
                    {revenue.stillRequired}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper right-align'>
                    {revenue.expertsDelivered}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper right-align'>
                    {revenue.expertsAccepted}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper right-align'>
                    {revenue.expertsInterviewed}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper right-align'>
                    {formatNumber(revenue.rev)}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper right-align'>
                    {formatNumber(revenue.hon)}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper right-align'>
                    {formatNumber(revenue.cost)}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper right-align'>
                    {formatNumber(revenue.margin)}
                  </span>
                </td>
                <td>
                  <b className='text-wrapper right-align'>
                    {this.renderMarginPercentage(revenue.hon, revenue.rev)}
                  </b>
                </td>
              </tr>
            </tbody>
          )
        })}
        <tfoot>
          <tr>
            <td>
              <span className='text-wrapper bold'>Total</span>
            </td>
            <td>
              <span className='text-wrapper' />
            </td>
            <td>
              <span className='text-wrapper' />
            </td>
            <td>
              <span className='text-wrapper' />
            </td>
            <td>
              <span className='text-wrapper' />
            </td>
            <td>
              <span className='text-wrapper' />
            </td>
            <td>
              <span className='text-wrapper' />
            </td>
            <td>
              <span className='text-wrapper right-align bold'>
                {stillRequiredSum}
              </span>
            </td>
            <td>
              <span className='text-wrapper right-align bold'>
                {expertsDeliveredSum}
              </span>
            </td>
            <td>
              <span className='text-wrapper right-align bold'>
                {expertsAcceptedSum}
              </span>
            </td>
            <td>
              <span className='text-wrapper right-align bold'>
                {expertsInterviewedSum}
              </span>
            </td>
            <td>
              <span className='text-wrapper right-align bold'>
                {formatNumber(revenueSum)}
              </span>
            </td>
            <td>
              <span className='text-wrapper right-align bold'>
                {formatNumber(honSum)}
              </span>
            </td>
            <td>
              <span className='text-wrapper right-align bold'>
                {formatNumber(costSum)}
              </span>
            </td>
            <td>
              <span className='text-wrapper right-align bold'>
                {formatNumber(marginSum)}
              </span>
            </td>
            <td>
              <span className='text-wrapper right-align bold'>
                {this.renderMarginPercentage(honSum, revenueSum)}
              </span>
            </td>
          </tr>
        </tfoot>
      </table>
    )
  }
}

export default inject('sidebarStore')(observer(RevenuesTable))
